import { 
    READ_QUESTIONS_BEGIN,
    READ_QUESTIONS_SUCCESS,
    READ_QUESTIONS_ERROR,
 } from './actions';

const initialState = {
    data: [],
    loading: false,
    error: null,
};

const ReadQuestionsDataReducer = (state = initialState, action) => {
    const { type, data, err } = action;
    switch (type) {
        case READ_QUESTIONS_BEGIN:
            return {
                ...state,
                loading: true,
            };
        case READ_QUESTIONS_SUCCESS:
            return {
                ...state,
                data,
                error: false,
                loading: false,
            };
        case READ_QUESTIONS_ERROR:
            return {
                ...state,
                error : err,
                loading: false,
            };
        default:
            return state;
    }
};

export { ReadQuestionsDataReducer };
